const { icons } = require('./constant');

const credit = {
	id: 'credit_master',
	title: 'Credit',
	type: 'collapse',
	icon: icons.IconCredit,
	children: [
		{
			id: 'bureauDecisions',
			title: 'Bureau Decisions',
			type: 'item',
			url: '/bureauDecisions',
			icon: icons.IconQualification,
			breadcrumbs: true,
		},
		{
			id: 'cibilDecisions',
			title: 'Cibil Decisions',
			type: 'item',
			url: '/cibilDecisions',
			icon: icons.IconQualification,
			breadcrumbs: true,
		},
		{
			id: 'coefficients',
			title: 'Coefficients',
			type: 'item',
			url: '/coefficients',
			icon: icons.IconQualification,
			breadcrumbs: true,
		},
	],
};

export default credit;
